export const SOURCE_LAYER = 'heat_detections';
export const SOURCE_ID = 'heat-detections';
export const REFRESH_INTERVAL_SECONDS = 60; // 1 minute, matches backend sync interval

export const CIRCLE_LAYER_ID = 'heat-detections-circle';
